export default __webpack_public_path__ + "static/media/Q12018.8dfedda5.PDF";